import { forwardRef, HTMLAttributes } from 'react';

import { cn } from '@/shared/lib/utils';
import { Typography } from '../Typography/Typography';
import { propertyType } from '@/entities/home_content/model/types';
import { buildingType } from '@/entities/knowledge/model/types';
import { formatPrice } from '@/shared/lib/utils/formatters';

export interface KnowledgeMiniCardProps extends HTMLAttributes<HTMLDivElement> {
  knowlendge: buildingType; // propertyType;
}

export const KnowledgeMiniCard = forwardRef<
  HTMLDivElement,
  KnowledgeMiniCardProps
>(({ className, knowlendge, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        'h-full w-full items-center justify-between bg-cover bg-center bg-no-repeat p-4 pb-[24px] md:p-[15px] md:pb-[25px]',
        className
      )}
      style={{
        backgroundImage: `linear-gradient(rgba(0,0,0,0.3),rgba(0,0,0,0.7)),url(${knowlendge.imageUrl || '/images/search_widget_bg.png'})`,
      }}
      {...props}
    >
      <div className="flex h-full flex-col justify-between">
        <Typography className="w-fit rounded-2xl bg-white px-[20px] py-[5px] text-[12px] leading-[0.95em] md:text-[16px]">
          {/* {knowlendge.title} */}
          {knowlendge.name}
        </Typography>
        <div className="flex flex-col gap-[18px] md:gap-[22px]">
          <Typography className="blur-cls w-fit rounded-2xl border border-white px-[20px] py-[5px] text-[12px] leading-[0.95em] text-white md:text-[16px]">
            {/* от {knowlendge.minArea} {knowlendge.areaUnit} */}
            от {formatPrice(knowlendge.totalArea.value)}{' '}
            {knowlendge.totalArea.unit}
          </Typography>
          <Typography className="blur-cls w-fit rounded-2xl px-[20px] py-[5px] text-[12px] leading-[0.95em] text-white md:text-[16px]">
            {/* от {knowlendge.minPrice} {knowlendge.currency} */}
            от {formatPrice(knowlendge.price.from)} {knowlendge.price.currency}
          </Typography>
        </div>
      </div>
    </div>
  );
});

KnowledgeMiniCard.displayName = 'KnowledgeMiniCard';
